module.exports = __webpack_public_path__ + "static/media/wxVideo.5e81dbb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxVideo.mp4
// module id = JQV9
// module chunks = 1